const ENTITY_BADGE_PALETTE = [
  '#A15C07',
  '#B93815',
  '#BC1B06',
  '#C01048',
  '#C11574',
  '#9F1AB1',
  '#5925DC',
  '#6927DA',
  '#3538CD',
  '#004EEB',
  '#175CD3',
  '#026AA2',
  '#0E7090',
  '#107569',
  '#087443',
  '#567C0F',
  '#3B7C0F',
  '#3F621A',
  '#363F72',
  '#6B21A8',
  '#B54708',
] as const;

function hashId(id: string): number {
  let hash = 0;
  for (let index = 0; index < id.length; index += 1) {
    hash = (hash * 31 + id.charCodeAt(index)) >>> 0;
  }
  return hash;
}

export function getEntityBadgeColor(id: string): string {
  const index = hashId(id) % ENTITY_BADGE_PALETTE.length;
  return ENTITY_BADGE_PALETTE[index] ?? ENTITY_BADGE_PALETTE[0];
}

export interface EntityTheme {
  backgroundColor: string;
  textColor: string;
}

const ENTITY_TEXT_COLOR = '#FFFFFF';

export function getEntityTheme(id: string): EntityTheme {
  return { backgroundColor: getEntityBadgeColor(id), textColor: ENTITY_TEXT_COLOR };
}

export { ENTITY_BADGE_PALETTE, ENTITY_TEXT_COLOR };
